export default __webpack_public_path__ + "static/media/home-restaurant-img-03.f02ea654.jpg";